import styled from 'styled-components';
import {
    TStyledMessagePreviewAddress,
    TStyledMessagePreviewDate,
    TStyledMessagePreviewWrapper,
    TStyledMessagePreviewMessage,
    TStyledMessagePreviewName,
    TStyledUnreadIndicator,
} from './thread-preview.types';

export const StyledThreadPreviewWrapper = styled.div<TStyledMessagePreviewWrapper>`
    width: 100%;
    padding: 0.8rem 1.6rem;
    background-color: ${({ active, theme }) =>
        active ? theme.color.grey2 : theme.color.white};
    border-bottom: 0.1rem solid ${({ theme }) => theme.color.grey3};
`;

export const StyledNameDateDiv = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const StyledRowTwoDiv = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const StyledNameDiv = styled.strong<TStyledMessagePreviewName>`
    overflow: hidden;
    color: ${({ active, unread, theme }) =>
        unread
            ? theme.color.purple
            : active
            ? theme.color.black
            : theme.color.grey7};
    font-size: 1.6rem;
    line-height: 2.4rem;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const StyledAddressAddress = styled.address<TStyledMessagePreviewAddress>`
    padding-right: 0.8rem;
    overflow: hidden;
    color: ${({ theme }) => theme.color.grey7};
    font-weight: ${({ unread }) => (unread ? 'bold' : 'normal')};
    font-size: 1.6rem;
    font-style: normal;
    line-height: 2.4rem;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const StyledMessagePreviewDiv = styled.div<TStyledMessagePreviewMessage>`
    overflow: hidden;
    color: ${({ active, theme }) =>
        active ? theme.color.grey7 : theme.color.grey6};
    font-size: 1.4rem;
    line-height: 2.2rem;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const StyledDateTime = styled.time<TStyledMessagePreviewDate>`
    flex: 1 0 auto;
    margin-left: 0.8rem;
    color: ${({ theme }) => theme.color.grey7};
    font-weight: ${({ unread }) => (unread ? 'bold' : 'normal')};
    font-size: 1.4rem;
    text-align: right;
`;

export const StyledUnreadIndicator = styled.div<TStyledUnreadIndicator>`
    padding: 0 0.5rem;
    line-height: 1.8rem;
    visibility: ${({ unread }) => (unread ? 'visible' : 'hidden')};
`;

export const StyledAnchor = styled.a`
    display: block;
    text-decoration: none;
`;
